// Capitalize first letter
export const capitalize = (str: string) => str.slice(0, 1).toUpperCase().concat(str.slice(1));
